import { render, staticRenderFns } from "./InicioColaborador.vue?vue&type=template&id=56f4f394&"
import script from "./InicioColaborador.vue?vue&type=script&lang=js&"
export * from "./InicioColaborador.vue?vue&type=script&lang=js&"
import style0 from "./InicioColaborador.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports